module.exports = __webpack_public_path__ + "static/img/icon2.11c62173.png";